// T-75: the person sets a Sessions row's level for themselves. Optimistic, like the channel pref,
// but reverted when the relay refuses it (a session they may not read).
import { canonicalAgentDmPeerId } from "../cybo-dm-peer-id.js";
import { notifPrefsState, workspaceState } from "../core/state.svelte.js";
import { reportUiFailure } from "../report-failure.js";
import { sessionScopeId, type SessionNotificationLevel } from "../session-notification-scope.js";
import { client } from "./client.js";

/** The scope a row (live session id or cybo id) is stored under. */
export function sessionRowScope(rowId: string): string {
  return sessionScopeId(canonicalAgentDmPeerId(workspaceState.agents, rowId));
}

export function sessionNotificationLevel(rowId: string): SessionNotificationLevel {
  return notifPrefsState.get(sessionRowScope(rowId)) === "muted" ? "muted" : "all";
}

export function sessionRowSilenced(rowId: string): boolean {
  return sessionNotificationLevel(rowId) === "muted";
}

export async function setSessionNotificationLevel(
  rowId: string,
  level: SessionNotificationLevel,
  wsId = workspaceState.current?.id,
): Promise<boolean> {
  if (!wsId) return false;
  const scope = sessionRowScope(rowId);
  const before = notifPrefsState.get(scope);
  notifPrefsState.set(scope, level);
  try {
    await client.setNotificationPref(wsId, scope, level);
    return true;
  } catch (err) {
    notifPrefsState.set(scope, before);
    reportUiFailure("sidebar.session_notification_level", err, { workspaceId: wsId });
    return false;
  }
}
